export default {
  // Form Title & Actions
  createPetProfile: "Create Pet Profile",
  editPet: "Edit Pet",
  back: "Back",
  previous: "Previous",
  next: "Next",
  complete: "Complete & Save",
  saving: "Saving...",
  saved: "Saved!",
  autoSaved: "Auto-saved",
  saveProgress: "Save Progress",
  autoSaveEnabled: "Auto-save enabled",
  saveFailed: "Save failed",
  saveDataError: "Failed to save data",
  retry: "Retry",
  close: "Close",
  cancel: "Cancel",
  ok: "OK",
  
  // Steps
  step: "Step",
  basicDetails: "Basic Details",
  physicalTraits: "Physical Traits",
  careNeeds: "Care Needs",
  healthRecords: "Health Records",
  review: "Review & Complete",
  
  // Tips & Help
  showTips: "Show Tips",
  hideTips: "Hide Tips",
  preview: "Preview",
  backToEditMode: "Back to Edit Mode",
  tagOperationHint: "Press Enter or comma to add tags, paste multiple items for auto-split",
  
  // Basic Info
  basicInfoTips: "Let's start with the essentials - your pet's name, type, and basic information",
  petPhoto: "Pet Photo",
  uploading: "Uploading...",
  enterPetName: "Enter your pet's name",
  name: "Name",
  nameRequired: "Name is required",
  nameHelpText: "e.g., Buddy, Luna, Max, Bella, Charlie",
  type: "Pet Type",
  typeRequired: "Pet type is required",
  breed: "Breed",
  specificBreed: "e.g., Golden Retriever, Persian Cat",
  breedHelpText: "e.g., Labrador, Beagle, Siamese, Maine Coon, Cockatiel",
  birthDate: "Birth Date",
  yearLabel: "Year",
  monthLabel: "Month",
  dayLabel: "Day",
  selectYear: "Year",
  selectMonth: "Month",
  selectDay: "Day",
  currentAge: "Current Age",
  age: "Age",
  birthDateCannotBeFuture: "Birth date cannot be in the future",
  birthDateTooOld: "Birth date seems too old (max {maxAge} years)",
  gender: "Gender",
  genderHelpText: "Select your pet's gender",
  male: "Male",
  female: "Female",
  notSpecified: "Not specified",
  microchipId: "Microchip ID",
  enterMicrochipId: "Enter microchip number",
  microchipHelpText: "e.g., 982000123456789 (15-digit number)",
  registrationId: "Registration ID",
  registrationIdHelpText: "e.g., Government registration number, Pet association member ID",
  currentLocation: "Current Location",
  currentLocationHelpText: "e.g., Home, At friend's house, Boarding facility, Vet clinic",
  
  // Pet Type Descriptions
  dog: "Dog",
  cat: "Cat",
  bird: "Bird",
  fish: "Fish",
  rabbit: "Rabbit",
  hamster: "Hamster",
  guinea_pig: "Guinea Pig",
  reptile: "Reptile",
  turtle: "Turtle",
  other: "Other",
  
  // Physical Traits
  physicalCharacteristicsDesc: "Record your pet's physical characteristics for health tracking",
  weight: "Weight",
  enterWeight: "e.g., 15 kg",
  weightHelpText: "Regular weighing helps monitor health changes",
  height: "Height",
  enterHeight: "e.g., 45 cm",
  heightHelpText: "Measure shoulder height (from ground to shoulder)",
  color: "Color",
  colorExample: "e.g., Golden, Black & White",
  colorHint: "e.g., Golden, Brown, Black, White, Gray, Spotted, Tabby, Calico",
  coatType: "Coat Type",
  coatTypeHint: "e.g., Short-haired, Long-haired, Curly, Silky, Wiry, Double-coat, Hairless",
  eyeColor: "Eye Color",
  eyeColorHint: "e.g., Brown, Blue, Green, Amber, Hazel, Heterochromia (different colors)",
  bodySize: "Body Size",
  bodySizeHint: "e.g., Toy, Small, Medium, Large, Giant",
  specialMarkings: "Special Markings",
  specialMarkingsHint: "e.g., White chest patch, Black ear tip, Heart-shaped spot, Scar on left leg",
  
  // Care Needs
  dietaryTips: "Set up feeding schedules and care requirements",
  dietaryInfo: "Dietary Information",
  feedingSchedule: "Feeding Schedule",
  addMeal: "Add Meal",
  time: "Time",
  timeHint: "Set feeding time, e.g., 8:00 AM, 6:00 PM",
  portionSize: "Portion Size",
  portionSizeExample: "e.g., 1 cup",
  portionSizeHint: "Record portion amount, e.g., 1 cup, 200g, half bowl, 2 tablespoons",
  foodType: "Food Type",
  foodTypeHint: "Record food category, e.g., Dry food, Wet food, Fresh food, Treats",
  noMealsAdded: "No meals added yet. Click 'Add Meal' to start.",
  canEat: "Can Eat",
  canEatHelpText: "List safe foods for your pet",
  canEatHint: "e.g., Chicken, Beef, Pumpkin, Sweet potato, Blueberries, Apples (no seeds), Carrots",
  cannotEat: "Cannot Eat",
  cannotEatHelpText: "List foods your pet should avoid",
  cannotEatHint: "e.g., Chocolate, Onions, Grapes, Avocado, Xylitol, Coffee, Garlic",
  
  behaviorInfo: "Behavior Information",
  likes: "Likes",
  whatPetEnjoys: "What does your pet enjoy?",
  likesHint: "e.g., Playing fetch, Swimming, Chasing, Catnip toys, Sunbathing, Belly rubs",
  dislikes: "Dislikes",
  whatMakesPetUncomfortable: "What makes your pet uncomfortable?",
  dislikesHint: "e.g., Baths, Nail trimming, Hair dryer, Strangers, Other animals, Thunder",
  temperament: "Temperament",
  temperamentExample: "e.g., Friendly, Shy, Energetic",
  temperamentHint: "e.g., Friendly, Gentle, Playful, Shy, Independent, Affectionate, Active, Calm",
  exerciseNeeds: "Exercise Needs",
  exerciseExample: "e.g., 30 minutes daily walk",
  exerciseNeedsHint: "e.g., Daily walks, Needs running space, Loves swimming, Apartment-friendly",
  
  // Health Records
  healthTips: "Keep track of medications and health information",
  healthInfo: "Health Information",
  medicationSchedule: "Medication Schedule",
  addMedication: "Add Medication",
  medicationName: "Medication Name",
  medicationPlaceholder: "e.g., Antibiotics",
  medicationNameHint: "Enter medication name, e.g., Heartworm prevention, Antibiotics, Joint supplement",
  dosage: "Dosage",
  dosagePlaceholder: "e.g., 10mg",
  dosageHint: "Record dosage amount, e.g., 10mg, 1 tablet, 5ml, half pill",
  frequency: "Frequency",
  frequencyHint: "Choose medication frequency: Daily, Twice daily, Weekly, or Custom",
  daily: "Daily",
  twiceDaily: "Twice Daily (BID)",
  thriceDaily: "Thrice Daily (TID)",
  weekly: "Weekly",
  monthly: "Monthly",
  custom: "Custom",
  dosageTimes: "Dosage Times",
  dosageTimesHint: "Set specific dosage times, e.g., 8:00 AM, 8:00 PM",
  addTime: "Add Time",
  noMedicationsAdded: "No medications added yet. Click 'Add Medication' to start.",
  
  vaccines: "Vaccines",
  vaccinesHelpText: "List all vaccines and dates",
  vaccinesHint: "e.g., Rabies, DHPP, Bordetella, Lyme disease, FVRCP (for cats)",
  nextVetVisit: "Next Vet Visit",
  nextVetVisitHelp: "Schedule your next veterinary appointment",
  allergies: "Allergies",
  knownAllergies: "List any known allergies",
  allergiesHint: "e.g., Pollen, Dust, Chicken, Beef, Fleas, Certain medications",
  medicalConditions: "Medical Conditions",
  chronicConditions: "Any chronic conditions?",
  medicalConditionsHint: "e.g., Heart disease, Diabetes, Arthritis, Kidney disease, Epilepsy, Thyroid issues",
  
  veterinarianInfo: "Veterinarian Information",
  vetName: "Veterinarian Name",
  yourPetsVet: "Your pet's vet name",
  vetNameHint: "e.g., City Animal Hospital, Dr. Smith's Clinic, Happy Paws Vet",
  vetPhone: "Vet Phone",
  emergencyContactPhone: "Emergency contact number",
  vetPhoneHint: "e.g., (555) 123-4567, +1-555-987-6543",
  vetAddress: "Vet Address",
  enterVetAddress: "Enter clinic address",
  vetAddressHint: "e.g., 123 Main Street, New York, NY 10001",
  vetEmail: "Vet Email",
  enterVetEmail: "Enter vet email",
  vetEmailHint: "e.g., clinic@example.com, drsmith@vet.com",
  insuranceProvider: "Insurance Provider",
  insuranceProviderHint: "e.g., Nationwide Pet Insurance, Trupanion, Healthy Paws",
  insurancePolicy: "Policy Number",
  insurancePolicyHint: "e.g., PET2024001234, INS-20240101-001",
  
  specialNotes: "Special Notes",
  additionalInfo: "Any additional information",
  specialNotesHint: "e.g., Afraid of thunder, Sensitive to certain sounds, Special care requirements, Behavior reminders",
  
  // Review
  reviewDescription: "Review all information before saving",
  profileCompletion: "Profile Completion",
  excellent: "Excellent",
  good: "Good",
  minimal: "Minimal",
  completeReviewTitle: "Complete Profile Review",
  completeProfilePreview: "Complete Profile Preview",
  unnamedPet: "Unnamed Pet",
  notFilled: "Not filled",
  editData: "Edit Data",
  
  // Save & Share
  enterNameToSave: "Enter pet name to enable saving",
  fillBasicInfoToSave: "Fill in basic info to save",
  petUpdatedSuccessfully: "Pet Updated Successfully!",
  petSavedSuccessfully: "Pet Saved Successfully!",
  nowYouCanShare: "Your pet profile is ready to share with others",
  shareNow: "Share Now",
  backToDashboard: "Back to Dashboard",
  continueEditing: "Continue Editing",
  errorOccurred: "Error Occurred",
  fixFormErrors: "Please Fix Form Errors",
  pleaseCheckAndFixErrors: "Please check and fix the errors in the form",
  saveBeforeShare: "Save Before Sharing",
  needToSaveBeforeSharing: "You need to save the pet profile before sharing",
  saveAndShare: "Save & Share",
  
  // Upload
  invalidFileType: "Invalid file type. Please upload an image.",
  fileTooLarge: "File too large. Maximum size is 5MB.",
  imageStoredLocally: "Image stored locally",
  imageUploadedSuccessfully: "Image uploaded successfully!",
  imageStoredAsBase64: "Image stored as Base64",
  
  // Tag Input
  tagHint: "Press Enter or comma to add",
  
  // Time units
  year: "year",
  years: "years",
  month: "month",
  months: "months",
  unknown: "Unknown"
};